import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
// import { GlobalContext } from "../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
} from "../../../../component/form/form-layout";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddLeadStatus = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  editData = {},
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();

  useEffect(() => {
    if (editData?.id) {
      formik.setFieldValue("status_code", editData?.status_code);
      formik.setFieldValue("status_name", editData?.status_name);
      formik.setFieldValue("category", editData?.category);
      formik.setFieldValue("recyclable", editData?.recyclable);
      formik.setFieldValue("recycle_days", editData?.recycle_days);
      formik.setFieldValue("requires_follow_up", editData?.requires_follow_up);
      formik.setFieldValue("description", editData?.description);
    }
  }, [editData]);

  const category = [
    {
      key: "Open",
      value: "Open",
    },
    {
      key: "Closed",
      value: "Closed",
    },
    {
      key: "Working",
      value: "Working",
    },
    {
      key: "Hot",
      value: "Hot",
    },
    {
      key: "Won",
      value: "Won",
    },
    {
      key: "Lost",
      value: "Lost",
    },
  ];

  const typeArray = [
    {
      key: "Yes",
      value: "yes",
    },
    {
      key: "No",
      value: "no",
    },
  ];

  const categoryList = category?.map((each) => ({
    value: each.value,
    label: each.key,
  }));
  const typeOptions = typeArray?.map((each) => ({
    value: each.value,
    label: each.key,
  }));

  const isChanged = () => {
    if (!editData?.id) return true; // new data
    return Object.keys(formik.values).some(
      (key) => formik.values[key] !== editData[key],
    );
  };

  const validationSchema = yup.object({
    status_code: yup

      .string("This Field is Required")
      .min(2, "Must be at least 2 characters")
      .max(5, "Must be at most 5 characters")
      .required("This Field is Required"),

    status_name: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    category: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    recyclable: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    recycle_days: yup
      .number("This Field is Required")
      .required("This Field is Required"),
    requires_follow_up: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    description: yup
      .string("This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      status_code: "",
      status_name: "",
      category: "",
      recyclable: "",
      recycle_days: "",
      requires_follow_up: "",
      description: "",
    },

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (!isChanged()) {
        console.log("No changes detected. API not called.");
        return;
      }

      let data = {
        status_code: values.status_code,
        status_name: values.status_name,
        category: values.category,
        recyclable: values.recyclable,
        recycle_days: values.recycle_days,
        requires_follow_up: values.requires_follow_up,
        description: values.description,
      };

      // console.log("Form data", values);
      // console.log("Extra meta" , extra_meta);

      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: editData?.id
            ? `status-config/update-status/${editData?.id}`
            : `status-config/add-status`,
          data: data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong",
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>{editData?.id ? "Edit Lead Status" : "Add Lead Status"}</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* Status Code */}
                  <FeildWraper>
                    <FormLabel required>Status Code</FormLabel>
                    <input
                      type="text"
                      name="status_code"
                      value={formik.values.status_code}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Status Code"
                    />
                    {formik.touched.status_code &&
                      formik.errors.status_code && (
                        <FeildError>{formik.errors.status_code}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Status Name */}

                  <FeildWraper>
                    <FormLabel required>Status Name</FormLabel>
                    <input
                      type="text"
                      name="status_name"
                      value={formik.values.status_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Status Name"
                    />
                    {formik.touched.status_name &&
                      formik.errors.status_name && (
                        <FeildError>{formik.errors.status_name}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Category */}
                  <FeildWraper>
                    <FormLabel required>Category</FormLabel>

                    <SelectSearch
                      name="category"
                      placeholder="- Select Category -"
                      onChange={(val) => {
                        formik?.setFieldValue("category", val);
                      }}
                      value={formik?.values.category}
                      options={categoryList}
                      onBlur={() =>
                        formik.setFieldTouched("category", true, true)
                      }
                      menuPosition="fixed"
                    />

                    {formik.touched.category && formik.errors.category && (
                      <FeildError>{formik.errors.category}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Recyclable  */}
                  <FeildWraper>
                    <FormLabel required>Recyclable</FormLabel>

                    <SelectSearch
                      name="recyclable"
                      placeholder="- Recyclable -"
                      onChange={(val) => {
                        formik?.setFieldValue("recyclable", val);
                      }}
                      value={formik?.values.recyclable}
                      options={typeOptions}
                      onBlur={() =>
                        formik.setFieldTouched("recyclable", true, true)
                      }
                      menuPosition="fixed"
                    />
                    {formik.touched.recyclable && formik.errors.recyclable && (
                      <FeildError>{formik.errors.recyclable}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Recycle Days */}
                  <FeildWraper>
                    <FormLabel required>Recycle Days</FormLabel>
                    <input
                      type="number"
                      name="recycle_days"
                      min="0"
                      value={formik.values.recycle_days}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      placeholder="Recycle Days"
                    />
                    {formik.touched.recycle_days &&
                      formik.errors.recycle_days && (
                        <FeildError>{formik.errors.recycle_days}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Require Follow Up */}

                  <FeildWraper>
                    <FormLabel required>Require Follow Up</FormLabel>

                    <SelectSearch
                      name="requires_follow_up"
                      placeholder="- Require Follow Up -"
                      onChange={(val) => {
                        formik?.setFieldValue("requires_follow_up", val);
                      }}
                      value={formik?.values.requires_follow_up}
                      options={typeOptions}
                      onBlur={() =>
                        formik.setFieldTouched("requires_follow_up", true, true)
                      }
                      menuPosition="fixed"
                    />
                    {formik.touched.requires_follow_up &&
                      formik.errors.requires_follow_up && (
                        <FeildError>
                          {formik.errors.requires_follow_up}
                        </FeildError>
                      )}
                  </FeildWraper>

                  {/* description */}
                  <FeildWraper width="100%">
                    <FormLabel required>Description</FormLabel>

                    <textarea
                      name="description"
                      value={formik.values.description}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      rows={6}
                      placeholder="Write description here..."
                    />
                    {formik.touched.description &&
                      formik.errors.description && (
                        <FeildError>{formik.errors.description}</FeildError>
                      )}
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button
            type="submit"
            className={`${Style.dcmb__submit} disabled:!opacity-70 disabled:!cursor-not-allowed`}
            disabled={!isChanged()}
          >
            {editData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddLeadStatus;
